export const authenticatorLinks = {
    'Play Market': 'https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2',
    'AppStore': 'https://apps.apple.com/us/app/google-authenticator/id388497605',
};
